import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { showError, showSuccess } from '../utils/alerts';
import { API_BASE_URL } from '../config';
import useMesesCerrados from '../hooks/useMesesCerrados';
import '../styles/pages/CargaCompras.css';
const meses = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
];


const CargaVentas = ({ token, id_company }) => {

    const [year, setYear] = useState('');
    const [files, setFiles] = useState(Array(12).fill(null));
    const [status, setStatus] = useState(Array(12).fill({ cargado: false, procesado: false }));
    const [loadingSii, setLoadingSii] = useState(Array(12).fill(false));
    const mesesCerrados = useMesesCerrados(id_company, year, token);
    const mesCerrado = (index) => !!mesesCerrados[index + 1];

    useEffect(() => {
      if (!year || !token) return;
      const fetchStatus = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/api/estado-ventas`, {
            params: { id_company, anual: year },
            headers: { Authorization: `Bearer ${token}` }
          });
          const newStatus = Array(12).fill({ cargado: false, procesado: false });
          response.data.forEach(row => {
            const idx = row.mes - 1;
            newStatus[idx] = { cargado: row.cargado, procesado: row.procesado };
          });
          setStatus(newStatus);
        } catch (error) {
          console.error('Error obteniendo estado de ventas', error);
        }
      };
      fetchStatus();
    }, [year, id_company, token]);

    const handleFileChange = (index, file) => {
    const newFiles = [...files];
    newFiles[index] = file;
    setFiles(newFiles);
  };

    const handleUpload = async (index) => {
    const file = files[index];
    if (!file || !year) {
        showError('Por favor selecciona un archivo y un año');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('id_company', id_company);
    formData.append('mes', index + 1);
    formData.append('anual', year);

    try {
      await axios.post(`${API_BASE_URL}/api/cargar/ventas`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      showSuccess(`Archivo de ${meses[index]} cargado exitosamente`);
      const newStatus = [...status];
      newStatus[index] = { cargado: true, procesado: false };
      setStatus(newStatus);
    } catch (error) {
      console.error('Error al cargar el archivo', error);
      showError(error.response?.data?.error || 'Error al cargar el archivo');
    }
  };

  const procesarVentas = async () => {

    if (!year) {
        showError('Selecciona un año');
        return;
      }
    try {
      await axios.post(
        `${API_BASE_URL}/api/procesar-ventas`,
        { id_company, anual: year },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
        );
      showSuccess('Registros de facturas de venta  procesados correctamente');
      const updated = status.map(s => ({ ...s, procesado: s.cargado ? true : s.procesado }));
      setStatus(updated);
    } catch (error) {
      console.error('Error al procesar los registros de facturas de ventas', error);
      showError('Error al procesar los registros de facturas de ventas');
    }
  };

  const consultarSii = async (index) => {
    if (!year) {
      showError('Por favor selecciona un año');
      return;
    }

    const newLoadingSii = [...loadingSii];
    newLoadingSii[index] = true;
    setLoadingSii(newLoadingSii);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/consultar-sii-ventas`,
        { id_company, year: parseInt(year), month: index + 1 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          timeout: 120000
        }
      );

      if (response.data.success) {
        const stats = response.data.data?.data?.stats || response.data.data?.stats;
        if (stats) {
          showSuccess(`${meses[index]}: ${stats.totalParsed || 0} registros obtenidos y procesados del SII`);
        } else {
          showSuccess(`Consulta de ${meses[index]} completada y procesada`);
        }

        // Actualizar estado local (el backend ya marcó cargado y procesado)
        setStatus(prevStatus => {
          const updated = [...prevStatus];
          updated[index] = { cargado: true, procesado: true };
          return updated;
        });
      } else {
        showError(response.data.error || 'Error en la consulta');
      }
    } catch (error) {
      console.error('Error al consultar SII:', error);
      const errorMsg = error.response?.data?.error || 'Error al consultar el SII';
      showError(errorMsg);
    } finally {
      const resetLoading = [...loadingSii];
      resetLoading[index] = false;
      setLoadingSii(resetLoading);
    }
  };

  const mesConsultando = loadingSii.findIndex(v => v);

  return (
    <div className="carga-compras">
      {loadingSii.some(v => v) && (
        <div className="sii-loading-overlay">
          <div className="sii-loading-modal">
            <div className="sii-loading-spinner"></div>
            <h3>Consultando SII</h3>
            {mesConsultando >= 0 && <p>{meses[mesConsultando]}</p>}
            <small>Por favor espere, no cierre esta ventana</small>
          </div>
        </div>
      )}
      <h1>Carga de Facturas de Venta</h1>

      <label htmlFor="yearSelect">Selecciona un Año:</label>
      <select
        id="yearSelect"
        value={year}
        onChange={(e) => setYear(e.target.value)}
      >
        <option value="">Selecciona un año</option>
        {[...Array(3)].map((_, i) => (
          <option key={i} value={2024 + i}>
            {2024 + i}
          </option>
        ))}
      </select>

      <table>
        <thead>
          <tr>
            <th>Mes</th>
            <th>Archivo</th>
            <th>Acción</th>
            <th>Cargado</th>
            <th>Procesado</th>
            <th>Consultar SII</th>
          </tr>
        </thead>
        <tbody>
          {meses.map((mes, index) => (
            <tr key={mes}>
              <td>{mes}{mesCerrado(index) && ' (Cerrado)'}</td>
              <td>
                <input
                  type="file"
                  accept=".csv"
                  onChange={(e) => handleFileChange(index, e.target.files[0])}
                  disabled={mesCerrado(index)}
                />
              </td>
              <td>
                <button
                  onClick={() => handleUpload(index)}
                  disabled={mesCerrado(index)}
                  title={mesCerrado(index) ? 'Mes cerrado' : undefined}
                >
                  Cargar
                </button>
              </td>
              <td className={status[index].cargado ? 'status-true' : ''}>
                {status[index].cargado ? 'Sí' : 'No'}
              </td>
              <td className={status[index].procesado ? 'status-true' : ''}>
                {status[index].procesado ? 'Sí' : 'No'}
              </td>
              <td>
                <button
                  onClick={() => consultarSii(index)}
                  disabled={loadingSii[index] || status[index].procesado || mesCerrado(index)}
                  title={mesCerrado(index) ? 'Mes cerrado' : undefined}
                >
                  {loadingSii[index] ? 'Consultando...' : 'Consultar SII'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button onClick={procesarVentas}>Procesar Ventas</button>
    </div>
  );



    
};


export default CargaVentas;